var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{staticClass:"w-toolbar-item",class:{disabled: _vm.disabled},attrs:{"to":_vm.computedTo,"disabled":_vm.disabled,"href":"javascript:void(0)"},nativeOn:{"click":function($event){return _vm.onClick($event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }